import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useOrganizationTableStore,
  initialOrganizationColumns,
} from 'views/pages/Admin/Organization/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

const MIN_VISIBLE_COLUMNS = 4;

type OrganizationColumnKey =
  'name' | 'user_count' | 'partner_count' | 'admin_count';

const ORGANIZATION_TABLE_COLUMN_LABELS: Record<OrganizationColumnKey, string> =
  {
    name: 'Name',
    user_count: 'Users',
    partner_count: 'Partners',
    admin_count: 'Admins',
  };

const ALL_FIELDS = initialOrganizationColumns.map(
  c => c.field,
) as OrganizationColumnKey[];

export const OrganizationTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useOrganizationTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useOrganizationTableStore(s => s.setHiddenColumns);

  const columns: Partial<
    Record<OrganizationColumnKey, ColumnPreferencesConfig>
  > = Object.fromEntries(
    ALL_FIELDS.map((field, index) => [
      field,
      {
        column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
        column_order: index,
        column_size: 160,
      } satisfies ColumnPreferencesConfig,
    ]),
  );

  const handleSelectionChange = (
    selection: Partial<Record<OrganizationColumnKey, ColumnPreferencesConfig>>,
  ) => {
    const nextHidden = ALL_FIELDS.filter(
      field => selection[field]?.column_display === 'hidden',
    );
    const visibleCount = ALL_FIELDS.length - nextHidden.length;
    if (visibleCount < MIN_VISIBLE_COLUMNS) return;
    setHiddenColumns(nextHidden);
  };

  return (
    <ColumnSelectionFilter
      name='organization_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={ORGANIZATION_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
